import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const NewDocument = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 151 64"
        data-fill-none
      >
        <rect
          x="0.5"
          y="0.5"
          width="150"
          height="63"
          rx="3.5"
          fill="#ECF2FF"
        />
        <rect
          x="0.5"
          y="0.5"
          width="150"
          height="63"
          rx="3.5"
          stroke="#C9DBFF"
        />
        <path
          d="M95.5394 48.4551H74.4971H62.4728H56.4607C54.8574 48.4551 53.4546 47.2107 53.4546 45.7884V19.1218C53.4546 17.6995 54.8574 16.4551 56.4607 16.4551H95.5394C97.1428 16.4551 98.5455 17.6995 98.5455 19.1218V45.7884C98.5455 47.2107 97.1428 48.4551 95.5394 48.4551Z"
          fill="white"
          stroke="#0C5CEF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="57.8184"
          y="29.209"
          width="18.9091"
          height="1"
          rx="0.5"
          fill="#0C5CEF"
        />
        <rect
          x="57.8184"
          y="33.1172"
          width="34.9091"
          height="1"
          rx="0.5"
          fill="#0C5CEF"
        />
        <rect
          x="57.8184"
          y="37.0273"
          width="27.6364"
          height="1"
          rx="0.5"
          fill="#0C5CEF"
        />
        <rect
          x="86.9092"
          y="4.81836"
          width="23.2727"
          height="23.2727"
          rx="11.6364"
          fill="#0C5CEF"
        />
        <path
          d="M98.5459 10.6367V22.2731"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M92.7275 16.4551H104.364"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
